import Call from '../Call';

const BidderSourcesWhitelist = {
    get(name) {
        return Call(`bidderSourcesWhitelist/${name}`);
    },
    save(name, feed, affids) {
        return Call(`bidderSourcesWhitelist/${name}`,'POST', { feed, affids });
    },
    remove(id) {
        return Call(`bidderSourcesWhitelist/${id}`,'DELETE');
    },
    removeAll(name) {
        return Call(`bidderSourcesWhitelist/all/${name}`,'DELETE');
    }
};

export default BidderSourcesWhitelist;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderSourcesWhitelist.js